import React, { useCallback } from 'react';

import { useUserContext } from 'providers/UserProvider';

import Table from 'components/common/Table';

import { inventoryApi, productApi } from 'api';

import {
  getInventoryHistoryListColumns,
  INVENTORY_HISTORY_FILTER_OPTIONS,
} from 'constants/inventory';

const InventoryHistory = () => {
  const { selectedTenant, selectedWarehouse } = useUserContext();
  const tenant = selectedTenant?.domains?.[0]?.domain;
  const warehouse = selectedWarehouse?.domain;

  const initialFilter = {
    warehouse: selectedWarehouse?.id,
    inventory_history_method: ['increase', 'force_update', 'decrease'],
  };

  const exportApi = useCallback(params => {
    return inventoryApi.getInventoryHistoryExport(params);
  }, []);

  return (
    <Table
      title="Inventory History"
      apiService={inventoryApi}
      exportApi={exportApi}
      sortable={true}
      columns={getInventoryHistoryListColumns(tenant, warehouse)}
      filterOptions={INVENTORY_HISTORY_FILTER_OPTIONS}
      initialPageSize={50}
      initialFilter={initialFilter}
      fetchConfig={{
        method: 'getInventoryHistoryList',
      }}
    />
  );
};

export default InventoryHistory;
